import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertOnboardingQuizContentHook } from "./quiz/ExpertOnboardingQuizContentHook";
// Set the default state values for each context
const ExpertOnboardingMCQContext = /*#__PURE__*/createContext({});
export const ExpertOnboardingMCQContextProvider = ({
  children,
  t
}) => {
  const mcqHook = useExpertOnboardingQuizContentHook(t);
  const memoMCQs = useMemo(() => ({
    ...mcqHook
  }), [mcqHook]);
  return /*#__PURE__*/React.createElement(ExpertOnboardingMCQContext.Provider, {
    value: memoMCQs
  }, children);
};
export const useExpertOnboardingMCQContext = () => {
  return useContext(ExpertOnboardingMCQContext);
};
ExpertOnboardingMCQContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  t: PropTypes.func.isRequired
};